exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdp-datepicker{display:inline-block;width:90%}.vdp-datepicker input{border:1px solid #ccc;border-radius:5px;height:34px;width:100%;padding:0 10px;cursor:pointer}.title-method{font-size:18px;font-weight:700;margin-top:0;border-bottom:1px solid #e8d7d7;padding-bottom:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ddeb68b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/important/important.vue
// module id = 1118
// module chunks = 0